import { keyframes, Box, Flex } from "@chakra-ui/react";

const wave = keyframes`
	0%, 60%, 100% {
		transform: initial;
	}

	30% {
		transform: translateY(-4px);
	}
`;

const Dot = ({ bg, ...rest }) => (
  <Box
    as="span"
    bg={bg}
    width="2px"
    height="2px"
    borderRadius="50%"
    mr="3px"
    animation={`${wave} 1.1s linear infinite`}
    sx={{
      ...rest
    }}
  />
);

export default function BouncingDotsLoader({ bg = "black54", mt }) {
  return (
    <Flex mt={mt} as="span">
      <Dot bg={bg} />
      <Dot bg={bg} animationDelay="-0.9s" />
      <Dot bg={bg} animationDelay="-0.7s" mr="0px" />
    </Flex>
  );
}
